import React, { useCallback, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SideMenu from "./components/sideMenu/SideMenu";
import Charts from "./pages/Charts";
import CurrenciesDetails from "./pages/CurrenciesDetails";
import Dashboard from "./pages/Dashboard";
import HomePage from "./pages/HomePage";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import Programs from "./pages/Programs";
import ProgramsStatus from "./pages/ProgramsStatus";
import Settings from "./pages/Setting";
import { PrivateRoutes } from "./PrivateRoutes";
import { GET_MARKET_PRICE } from "./redux/actions/constants";
import { getInitialCurrenciesSettingsAction } from "./redux/actions/currenciesActions";
import ACTIVE_SERVER from "./services/config";
import { currencies } from "./staticData/currencies";
import { connectionClass } from "./websocket/socket";

const App = () => {
    const { isDarkMode, userInfo } = useSelector(
        (state) => state.persistedReducer,
        (oldValue, newValue) => {
            if (
                oldValue.isDarkMode !== newValue.isDarkMode ||
                oldValue.userInfo.accountInfo.accountName !==
                    newValue.userInfo.accountInfo.accountName
            ) {
                return false;
            }
            return true;
        }
    );
    const dispatch = useDispatch();
    // Check if the code has already run in this session
    const hasCodeRun = sessionStorage.getItem(`${ACTIVE_SERVER.serverName}-hasMarketDataArrived`);
    useEffect(() => {
        if (!hasCodeRun) {
            connectionClass.socketInfo.emit("candle_data_req");
            sessionStorage.setItem(`${ACTIVE_SERVER.serverName}-hasMarketDataArrived`, true);
        }
    }, []);

    useEffect(() => {
        connectionClass.socketInfo.off("candle_data");
        connectionClass.socketInfo.on("candle_data", (candleData) => {
            for (const currency of Object.values(currencies)) {
                const { currencyId } = currency;
                if (candleData[currencyId]) {
                    dispatch({
                        type: GET_MARKET_PRICE,
                        payload: { currencyId, data: candleData[currencyId] }
                    });
                }
            }
        });

        connectionClass.socketInfo.on("live_candle_data", (data) => {
            dispatch({
                type: GET_MARKET_PRICE,
                payload: { currencyId: data.currencyId, data: data.closePrice }
            });
        });
    }, []);
    return (
        <div className={isDarkMode ? "bg-primaryDark text-white" : "bg-primaryLight text-black"}>
            <Routes>
                <Route element={<PrivateRoutes />}>
                    <Route element={<SideMenu />}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/programs-status" element={<ProgramsStatus />} />
                        <Route path="/charts" element={<Charts />} />

                        <Route path="/settings" element={<Settings />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/currenciesDetails" element={<CurrenciesDetails />} />
                        <Route path="/programsstatus" element={<Programs />} />
                    </Route>
                </Route>
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </div>
    );
};

export default App;
